import React from 'react'
import { createPortal } from 'react-dom'
import { Dropdown } from 'react-bootstrap'
import { getWindow } from '@ztechapps/common.utils'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { ComposerModeEnum, useConversationContext } from './Context'
import styles from './ComposerModeToggle.module.scss'

// The reply-mode switch in the editor header. The Internal note item is not listed while the
// mount has no conversation — a note is stored on the conversation, so there is nothing to attach
// it to yet; the toggle itself is always on screen.
export const ComposerModeToggle = () => {
  const { conversationId, composerMode, setComposerMode } = useConversationContext()
  const isPublicMode = composerMode === ComposerModeEnum.Public

  // The menu portals to the body so it drops clear of the editor header instead of
  // clipping inside it — Bootstrap's own dropdown layer already clears the flyout panel
  // and the title band, so no z-index is written here. A ternary, not a ShowIf: the
  // hidden branch must stay unbuilt until the body exists.
  const portalTarget = getWindow()?.document.body

  return (
    <Dropdown>
      <Dropdown.Toggle variant="link" className={`fw-semibold ${styles.composerModeToggle}`}>
        <span aria-hidden="true" className="me-1">
          <Icon name={isPublicMode ? 'reply' : 'lock'} />
        </span>
        {composerMode}
      </Dropdown.Toggle>
      {/* Rendered through a fragment — the same shape every other body portal in the
          tree uses (RichTextInput.tsx, FileUploader): Dropdown's typed children prop
          rejects the portal value directly, while the fragment still keeps the menu
          in Dropdown's tree so open/close and item clicks keep working. */}
      {portalTarget ? (
        <>
          {createPortal(
            <Dropdown.Menu>
              <Dropdown.Item active={isPublicMode} onClick={() => setComposerMode(ComposerModeEnum.Public)}>
                <span aria-hidden="true" className="me-1">
                  <Icon name="reply" />
                </span>
                {ComposerModeEnum.Public}
              </Dropdown.Item>
              <ShowIf condition={!!conversationId}>
                <Dropdown.Item active={!isPublicMode} onClick={() => setComposerMode(ComposerModeEnum.Note)}>
                  <span aria-hidden="true" className="me-1">
                    <Icon name="lock" />
                  </span>
                  {ComposerModeEnum.Note}
                </Dropdown.Item>
              </ShowIf>
            </Dropdown.Menu>,
            portalTarget
          )}
        </>
      ) : null}
    </Dropdown>
  )
}
